import { ref, computed, watch } from "vue";
import { useStore } from "vuex";

export default function useFilterOptions() {
  const store = useStore();

  const device_filter = computed(
    () => store.getters["devicesFilterOptions/getFilterOptions"]
  );
  const loading = computed(
    () => store.getters["devicesFilterOptions/getLoading"]
  );
  const deviceQuery = computed(
    () => store.getters["windtagDevices/getDeviceQuery"]
  );

  let devicesFilter = deviceQuery.value;

  let courses = computed(() => store.getters["courses/getCourseNames"]);

  const course = ref([]);
  const filteredDevices = ref([]);
  const windtagDeviceClass = ref([]);
  const primaryCourses = computed(() => device_filter.value?.courses || []);
  const windtagDeviceClasses = computed(
    () => device_filter.value?.windtagDeviceClass || []
  );
  watch(course, (newValue) =>
    updateActiveFilters(
      "courses",
      newValue.map((item) => item.id)
    )
  );
  watch(windtagDeviceClass, (newValue) =>
    updateActiveFilters(
      "device_classes",
      newValue.map((item) => item.id)
    )
  );

  const updateActiveFilters = (key, value) => {
    if (Array.isArray(value) && value.length > 0) {
      devicesFilter[key] = value;
    } else if (typeof value === "string" && value !== "") {
      devicesFilter[key] = value;
    } else {
      delete devicesFilter[key];
    }

    store.dispatch("windtagDevices/setDeviceQuery", devicesFilter);
  };

  const filterDevices = async () => {
    try {
      devicesFilter.filterApplied = true;
      await store.dispatch("windtagDevices/setDeviceQuery", devicesFilter);
      await store.dispatch("windtagDevices/fetchWindtagDevices");
    } catch (error) {
      console.log(error);
    }
  };

  return {
    loading,
    course,
    courses,
    primaryCourses,
    windtagDeviceClass,
    windtagDeviceClasses,
    filterDevices,
    filteredDevices,
  };
}
